import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  breadcrumbs_panel: {
    marginBottom: 25
  }
}));
